import React, { useEffect } from 'react';
import Page from '../page';
import Loader from '../loader/loader';
import { useGetDesignQuery } from '../../store/slices/apiSlice/design-api-slice';
import { handleBackendError } from '../../utilities/errorHandling';
import DesignTable from '../designTable';

function DesignDashboard() {
    const { data: designData, error, isLoading } = useGetDesignQuery();

    useEffect(() => {
        if (error) {
            handleBackendError('Get Design Data', error);
        }
    }, [error]);

    return (
        <Page>
            <div className="ps-0 ps-md-4 pe-2 pe-sm-0 pe-xs-0">
                <h1 className="mt-2">Design Dashboard</h1>
                {isLoading ? (
                    <Loader />
                ) : error ? null : (
                    <DesignTable projects={designData?.projects} />
                )}
            </div>
        </Page>
    );
}

export default DesignDashboard;
